@if (!userAccountNotActive) {
  <form
    [formGroup]="loginForm"
    (ngSubmit)="onSubmit()"
  >
    <div
      class="form-group"
      [class.hidden]="joiningEvent()"
    >
      <label for="username"
        >{{ 'Username' | translate }}/{{ 'Email' | translate }}</label
      >
      <input
        id="username"
        type="text"
        class="form-control"
        formControlName="username"
      />
      @if (username.invalid && (username.dirty || username.touched)) {
        <div class="alert alert-danger">
          @if (username.errors.required) {
            <div translate>User Name is required.</div>
          }
        </div>
      }
      <small>
        {{ 'UI.Validation.NoSpace' | translate }}
      </small>
    </div>
    <div class="form-group">
      <label
        for="password"
        translate
        >Password</label
      >
      <div class="input-group">
        <input
          id="password"
          [type]="passwordDisplayed ? 'text' : 'password'"
          class="form-control"
          formControlName="password"
        />
        <div class="input-group-text">
          <button
            type="button"
            class="btn-unstyled d-flex align-items-center"
            (click)="togglePassword($event)"
          >
            <ng-icon
              [name]="passwordDisplayed ? 'matVisibilityOff' : 'matVisibility'"
              aria-hidden="true"
            ></ng-icon>
          </button>
        </div>
      </div>
      @if (password.invalid && (password.dirty || password.touched)) {
        <div class="alert alert-danger">
          @if (password.errors.required) {
            <div>
              {{ 'UI.Validation.PasswordIsRequired' | translate }}
            </div>
          }
        </div>
      }

      @if (!joiningEvent()) {
        <div class="text-end">
          <a
            href=""
            class="forgot-password-link"
            translate
            (click)="toggleForgotPasswordForm($event)"
            >ForgotPassword</a
          >
        </div>
      }
    </div>

    <div class="login-options-row form-check">
      <input
        type="checkbox"
        class="form-check-input"
        id="remember-me"
        formControlName="rememberMe"
      />

      <label
        class="form-check-label"
        for="remember-me"
        translate
        >KeepMeLoggedIn</label
      >
    </div>

    <div
      *ngIf="loginForm.errors && (loginForm.dirty || loginForm.touched)"
      class="alert alert-danger"
      translate
    >
      {{ errorMessage[formErrorKey] }}
    </div>
    <div
      [class.text-center]="!joiningEvent()"
      class="form-group"
    >
      <button
        type="submit"
        class="btn btn-primary"
        [disabled]="
          !loginForm.valid ||
          isSubmitting ||
          !(loginForm?.touched || loginForm?.dirty)
        "
      >
        @if (isSubmitting) {
          <span
            class="spinner-border spinner-border-sm"
            aria-hidden="true"
          ></span>
        }
        <span translate>Login</span>
      </button>
    </div>

    @if (!joiningEvent()) {
      <app-login-with-linkedin-btn
        [assignToOrgId]="assignToOrgId"
        [redirectParams]="linkedinRedirectParams"
      ></app-login-with-linkedin-btn>
    }
  </form>
} @else {
  <div class="email-confirmation">
    <div class="email-confirmation__info mt-4">
      <span
        class="info-text"
        [innerHTML]="
          'UI.UserNotActive.Inform-email-sent'
            | translate
            | stringReplacement
              : {
                  '{portalName}':
                    'https://' + portalUrl | linkWrapper: portalName,
                  '{userEmail}':
                    this.sentEmailAddress | emailWrapper: this.sentEmailAddress,
                }
        "
      ></span>
      <span
        class="info-text"
        translate
        >UI.UserNotActive.Inform-follow-link</span
      >
      <span class="mt-3">
        <b translate>UI.UserNotActive.Didnot-receive-email</b>
        <span
          class="ms-2"
          translate
          >UI.UserNotActive.Please-check-your-spam</span
        >
      </span>
    </div>
    @if (loginForm.errors) {
      <div
        class="alert alert-danger"
        translate
      >
        {{ errorMessage[formErrorKey] }}
      </div>
    }
    <div class="form-group text-center email-confirmation__buttons mb-3">
      <button
        type="button"
        appDebounceClick
        (debounceClick)="resendConfirmationEmail(this.sentEmailAddress)"
        class="btn btn-secondary"
        [disabled]="isSubmitting"
      >
        @if (isSubmitting) {
          <span
            class="spinner-border spinner-border-sm"
            aria-hidden="true"
          ></span>
        }
        <span>{{ 'UI.UserNotActive.Resend-email' | translate }}</span>
      </button>

      <button
        class="btn btn-primary ms-3"
        appDebounceClick
        (debounceClick)="stateReset.emit($event)"
      >
        {{ 'UI.UserNotActive.OK' | translate }}
      </button>
    </div>
  </div>
}
